import $ from 'jquery'
import '../scss/module_subscribe.scss';

import Collapse from 'bootstrap/js/dist/collapse'
import Modal from 'bootstrap/js/dist/modal'
import Dropdown from 'bootstrap/js/dist/dropdown'

import {doLast} from './module_last';
import { initFirebaseApp } from './module_firebase';
import { manageLogin } from './module_auth_helper';

import {
    funnelUpdateWhenAvailable, 
    freeTrialManage,
    updateBuyButtonCta,
    updateBuyButtonDescription,
    doSelectPlan,
} from './module_common';

import './module_common_actions';

import { initNavbar } from './module_header';
import { attachToCheckoutButtonClick, manageBuyButtonClick, reviewCarouselSetUp } from './module_landing_offer_common';
import { initSentry } from './module_sentry';

window.doSelectPlan = doSelectPlan;

const evaluateMarkerPosition = function(mark, target){
    if (window.innerWidth > 450) return;
    let threshold = mark.offset().top;
    let wh = window.innerHeight;
    let ws = $(window).scrollTop();
    let current = wh + ws;
    if ( current < threshold) {
        if (!target.hasClass('is-hidden')){
            target.addClass('is-hidden');
        }
    } else {
        if (target.hasClass('is-hidden')){
            target.removeClass('is-hidden');
        }
    }
}

const manageMarker = function(){
    if(!$('#action-marker-subscribe').length) return;
    const mark = $('#action-marker-subscribe');
    const target = $('.button-mobile.hidden');
    evaluateMarkerPosition(mark, target);
    $(window).scroll(function() {
        evaluateMarkerPosition(mark, target);
    });
}

function subsManageBuyButtonClick(){
    manageBuyButtonClick()
}

function attachBuyButtonClick(){
    $('.buy-btn-attach-clk').on('click', function(e){
        subsManageBuyButtonClick()
    })
}

function attachHeaderBuyButtonClick(){
    $('.header-subscribe-btn-attach-clk').on('click', function(e){
        subsManageBuyButtonClick()
    })
}

document.addEventListener("DOMContentLoaded", () => {
    initSentry()
    initFirebaseApp()
    manageLogin()
    
    doLast()
    initNavbar()
    const plan = allPlans[selectedPlan]
    freeTrialManage(plan.trialPeriod)
    updateBuyButtonCta(plan.label)
    updateBuyButtonDescription(plan.description)

    attachBuyButtonClick()
    attachHeaderBuyButtonClick()
    attachToCheckoutButtonClick()

    reviewCarouselSetUp()

    manageMarker()

    if (!isPageReloadedAfterLogin) funnelUpdateWhenAvailable('checkout_viewed');
});